import { useState } from "react";
import TopNav from "./components/TopNav";
import BreakingTicker from "./components/BreakingTicker";
import HeroSection from "./components/HeroSection";
import LiveFeed from "./components/LiveFeed";
import HotGrid from "./components/HotGrid";
import EventTrack from "./components/EventTrack";
import TopicBoard from "./components/TopicBoard";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import SiteFooter from "./components/SiteFooter";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "爆料网的内容多久更新一次？",
      acceptedAnswer: { "@type": "Answer", text: "爆料网实行全天候滚动更新，实时爆料栏目跟随热点事件不断刷新，热门事件配合热点追踪持续补充最新进展。" },
    },
    {
      "@type": "Question",
      name: "如何判断一条爆料的真实性？",
      acceptedAnswer: { "@type": "Answer", text: "我们优先采用多方信源交叉核实的内容，无法第一时间证实的信息会明确标注来源与核实状态，并在热点追踪中跟进回应与澄清。" },
    },
    {
      "@type": "Question",
      name: "爆料网是否只报道娱乐圈内容？",
      acceptedAnswer: { "@type": "Answer", text: "不止于此，我们还覆盖音乐现场、电竞游戏、体坛风云、科技数码与社会民生等多个栏目。" },
    },
    {
      "@type": "Question",
      name: "我能通过爆料网反馈线索或投稿吗？",
      acceptedAnswer: { "@type": "Answer", text: "可以，欢迎通过文末的联系邮箱与我们沟通，我们会认真核查每条线索并在核实后纳入相关栏目与热点追踪。" },
    },
  ],
};

const schemaBlock = [
  {
    "@type": "WebPage",
    "@id": "/",
    url: "/",
    name: "爆料网 - 今日热点、实时爆料与全网热瓜追踪",
    description: "爆料网专注今日热点与实时爆料，滚动追踪娱乐圈、影视综艺、体坛赛事与网络热门事件。",
    inLanguage: "zh-CN",
  },
  {
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页" },
      { "@type": "ListItem", position: 2, name: "今日热点" },
      { "@type": "ListItem", position: 3, name: "实时爆料与全网热瓜" },
    ],
  },
];

export default function Home() {
  const [search, setSearch] = useState("");

  const scrollToLive = () => {
    const el = document.getElementById("live");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify({ "@context": "https://schema.org", "@graph": schemaBlock }) }}
      />
      <div className="pt-16 md:pt-[68px] min-h-screen bg-background-50">
        <TopNav search={search} onSearchChange={setSearch} onSearchActive={scrollToLive} />
        <BreakingTicker />
        <main>
          <HeroSection />
          <LiveFeed search={search} />
          <HotGrid />
          <EventTrack />
          <TopicBoard />
          <AboutSection />
          <FaqSection />
        </main>
        <SubscribeSection />
        <SiteFooter />
      </div>
    </>
  );
}